module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group-panel"
  }, [_c('div', {
    staticClass: "group-heading",
    class: {
      collapsed: _vm.collapsed
    },
    on: {
      "click": _vm.toggleCollapse
    }
  }, [_c('div', {
    staticClass: "group-heading-label"
  }, [_vm._v(_vm._s(_vm.schema.label) + "\n            "), _c('v-icon', {
    staticClass: "collapse-button",
    class: {
      collapsed: _vm.collapsed
    },
    staticStyle: {
      "margin-top": "-3px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-up")])], 1)]), _vm._v(" "), _c('v-expand-transition', [(_vm.schema && !_vm.collapsed) ? _c('div', {
    staticClass: "pt-3 pl-3"
  }, [_c('ControlList', {
    attrs: {
      "horizontal": _vm.schema.horizontal,
      "schema": _vm.schemaFields,
      "value": _vm.value
    },
    on: {
      "change": _vm.emitChanges
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74939ac1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/SectionControl.vue
// module id = 2605
// module chunks = 1